<form [formGroup]="form">
  <ng-container *ngIf="fromMedicalConsultation; else isNotfromMedicalConsultation">
    <div class="medico-fecha-container centered">
      <ng-container *ngIf="disabledDates; else enabledDate">
        <div class="d-flex mb-1" style="align-items: end">
          <div class="d-flex">
            <h6 class="text-uppercase title">Fecha</h6>
            <span class="text-danger mr-2">*</span>
          </div>
          <input nbInput [nbDatepicker]="datepicker" formControlName="date" placeholder="Fecha" readonly />
          <nb-datepicker #datepicker [filter]="filterFn" format="dd/MM/yyyy"></nb-datepicker>
        </div>
      </ng-container>
      <ng-template #enabledDate>
        <div class="d-flex mb-1" style="align-items: center">
          <h6 class="text-uppercase mr-2 my-auto title">Fecha</h6>
          <input nbInput placeholder="Fecha" [value]="date | dateBasic" readonly />
        </div>
      </ng-template>
    </div>
  </ng-container>
  <ng-template #isNotfromMedicalConsultation>
  </ng-template>
</form>
